module.exports = __webpack_public_path__ + "img/16.25ca72c2.png";